import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VDialog, {
    attrs: {
      "max-width": "950"
    },
    model: {
      value: _vm.subscribtionInvitationModalShown,
      callback: function callback($$v) {
        _vm.subscribtionInvitationModalShown = $$v;
      },
      expression: "subscribtionInvitationModalShown"
    }
  }, [_c(VCard, {
    attrs: {
      loading: _vm.form.sending
    }
  }, [_c("div", {
    staticClass: "dialog-closer"
  }, [_c(VIcon, {
    staticClass: "far fa-times-circle",
    attrs: {
      disabled: _vm.form.sending
    },
    on: {
      click: function click($event) {
        return _vm.close();
      }
    }
  })], 1), _c(VCardTitle, [_c("span", {
    staticClass: "text-h5 mb-4"
  }, [_vm._v("Send invitations to subscribe")])]), _c(VCardText, [_c(VForm, {
    ref: "form",
    model: {
      value: _vm.form.valid,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "valid", $$v);
      },
      expression: "form.valid"
    }
  }, [_c(VCombobox, {
    staticClass: "required",
    attrs: {
      chips: "",
      outlined: "",
      clearable: "",
      label: "To(s)",
      multiple: "",
      "append-icon": "",
      rules: [_vm.rules.mustNotBeEmpty, _vm.rules.mustBeEmails]
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function fn(_ref) {
        var attrs = _ref.attrs,
          item = _ref.item;
        return [_c(VChip, _vm._b({
          attrs: {
            close: ""
          },
          on: {
            "click:close": function clickClose($event) {
              return _vm.removeMail(item);
            }
          }
        }, "v-chip", attrs, false), [_c("strong", [_vm._v(_vm._s(item))])])];
      }
    }]),
    model: {
      value: _vm.form.items,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "items", $$v);
      },
      expression: "form.items"
    }
  }), _c(VTextarea, {
    attrs: {
      placeholder: "This message will be surrounded by standard invitation message.",
      outlined: "",
      "hide-details": "auto"
    },
    model: {
      value: _vm.form.message,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "message", $$v);
      },
      expression: "form.message"
    }
  })], 1)], 1), _c(VCardActions, [_c(VBtn, {
    staticClass: "dfwa-btn --small secondary",
    attrs: {
      rounded: "",
      disabled: _vm.form.sending
    },
    on: {
      click: function click($event) {
        return _vm.close();
      }
    }
  }, [_vm._v(" Cancel ")]), _c(VBtn, {
    staticClass: "dfwa-btn --small",
    attrs: {
      rounded: "",
      disabled: !_vm.form.valid,
      loading: _vm.form.sending
    },
    on: {
      click: function click($event) {
        return _vm.sendInvites();
      }
    }
  }, [_vm._v(" Send ")])], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };